// extracted by mini-css-extract-plugin
export default {"wrapper":"sFRVAb4","bidRangeRow":"Xqbq6mM","bidColumn":"YMeb9Z9","bidRange":"mEItuGg"};